import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'xAxisLabel',
})
export class XAxisLabelPipe implements PipeTransform {
  transform(value: string): string {
    return (value.length > 6) ? value.slice(0, 6) + '...' : value;
  }
}
